const moduleKey = "timezoneDate";

export const timezoneDateEn = {
  [moduleKey]: {
    today: "Today",
    yesterday: "Yesterday",
    at: "at",
  },
};

export const timezoneDatePtBr = {
  [moduleKey]: {
    today: "Hoje",
    yesterday: "Ontem",
    at: "em",
  },
};

export const timezoneDateDe = {
  [moduleKey]: {
    today: "Heute",
    yesterday: "Gestern",
    at: "um",
  },
};

export const timezoneDateZhHans = {
  [moduleKey]: {
    today: "今天",
    yesterday: "昨天",
    at: "于",
  },
};

export const timezoneDateIt = {
  [moduleKey]: {
    today: "Oggi",
    yesterday: "Ieri",
    at: "a",
  },
};

export const timezoneDateEs = {
  [moduleKey]: {
    today: "Hoy",
    yesterday: "Ayer",
    at: "en",
  },
};

export const timezoneDateNl = {
  [moduleKey]: {
    at: "om",
    today: "Vandaag",
    yesterday: "Gisteren",
  },
};

export const timezoneDateTr = {
  [moduleKey]: {
    at: "en",
    today: "Bugün",
    yesterday: "Dün",
  },
};
